import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { Toast } from './toastr.service';
import { trigger, state, style, animate, transition, AnimationEvent } from '@angular/animations';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-toast-item',
  templateUrl: './toast-item.component.html',
  styleUrls: ['./toast-item.component.scss'],
  standalone: false,
  animations: [
    trigger('toastAnimation', [
      state('void', style({
        transform: 'translateY(2rem)',
        opacity: 0
      })),
      state('visible', style({
        transform: 'translateY(0)',
        opacity: 1
      })),
      state('hidden', style({
        transform: 'translateY(-2rem)',
        opacity: 0
      })),
      transition('void => visible', animate('300ms ease-out')),
      transition('visible => hidden', animate('200ms ease-in'))
    ])
  ]
})
export class ToastItemComponent implements OnInit, OnDestroy, OnChanges {
  @Input() toast!: Toast;
  @Output() close = new EventEmitter<number>();

  private progressInterval: any;

  constructor(private _cdr: ChangeDetectorRef) {}

  optionsSuccess: AnimationOptions = {
    path: '/assets/lotties/success.json', loop: false
  };
  optionsFailed: AnimationOptions = {
    path: '/assets/lotties/failed.json', loop: false
  };
  optionsWelcome: AnimationOptions = {
    path: '/assets/lotties/welcome.json', loop: false
  };

  ngOnInit() {
    if (this.toast.duration && this.toast.duration > 0) {
      this.startProgressTimer();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['toast'] && !changes['toast'].firstChange) {
      // L'état du toast a changé
    }
  }

  ngOnDestroy() {
    if (this.progressInterval) {
      clearTimeout(this.progressInterval);
    }
  }

  private startProgressTimer() {
    const updateInterval = 16; // ~60fps pour une animation fluide
    const startTime = Date.now();
    const duration = this.toast.duration || 5000;
    
    const updateProgress = () => {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(0, duration - elapsed);
      
      this.toast.remainingTime = remaining;
      this._cdr.detectChanges();
      
      if (remaining > 0) {
        this.progressInterval = setTimeout(updateProgress, updateInterval);
      } else {
        // Démarrer l'animation de fermeture
        this.toast.state = 'hidden';
        this._cdr.detectChanges();
        // Le toast sera supprimé du DOM dans onAnimationDone
      }
    };
    
    // Démarrer immédiatement
    updateProgress();
  }

  onAnimationDone(event: AnimationEvent) {
    if (event.toState === 'hidden') {
      this.close.emit(this.toast.id);
    }
  }

  onAnimationStart(event: AnimationEvent) {
    // L'animation commence
  }

  getProgressValue(): number {
    if (!this.toast.duration || this.toast.duration === 0) {
      return 0;
    }
    const progress = ((this.toast.remainingTime || 0) / this.toast.duration) * 100;
    return Math.max(0, Math.min(100, progress));
  }

  onCloseClick() {
    if (this.progressInterval) {
      clearTimeout(this.progressInterval);
    }
    this.toast.state = 'hidden';
  }
} 